// src/components/ui/BottomNav.tsx
import * as React from "react";
import { NavLink } from "react-router-dom";
import { useKeyboardOpen } from "../../../hooks/useKeyBoardOpen";
import { cn } from "../../../lib/utils/cn";

type ImgIcon = {
  active: string; // 활성 이미지 src
  inactive: string; // 비활성 이미지 src
  alt?: string;
  size?: number; // px (기본 20)
};

type Item = {
  to: string;
  label: string;
  img?: ImgIcon; // ← 이미지 아이콘
  icon?: React.ReactNode; // (선택) 기존 아이콘도 계속 지원
};

type BottomNavProps = {
  items: Item[];
  height?: number; // 바 높이 (기본 60)
  className?: string;
};

export default function BottomNav({
  items,
  height = 72,
  className,
}: BottomNavProps) {
  const { isOpen } = useKeyboardOpen();

  return (
    <nav
      aria-label="하단 내비게이션"
      role="navigation"
      className={[
        "sticky bottom-0 z-10",
        "w-full backdrop-blur transition-transform duration-150 bg-[#f5f5f5] max-w-[440px]",
        isOpen ? "translate-y-full pointer-events-none" : "translate-y-0",
        className || "",
      ].join(" ")}
      // style={{ paddingBottom: "var(--safe-area-inset-bottom)" }}
    >
      <ul
        className="mx-auto grid w-full"
        style={{
          gridTemplateColumns: `repeat(${items.length}, minmax(0,1fr))`,
          height,
        }}
      >
        {items.map(({ to, label, img, icon }) => (
          <li key={to} className="contents">
            <NavLink
              to={to}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center space-y-[2px]  ${
                  isActive ? "text-black" : "text-gray-500"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {img ? (
                    <img
                      src={isActive ? img.active : img.inactive}
                      alt={img.alt ?? label}
                      width={24}
                      height={24}
                      className="block"
                      draggable={false}
                    />
                  ) : (
                    (icon ?? (
                      <span className="block h-4 w-4 rounded-full border" />
                    ))
                  )}
                  <span
                    className={cn(
                      "font-[500] text-[12px] leading-normal my-0",
                      isActive ? "text-primary" : "text-[#222222]",
                    )}
                  >
                    {label}
                  </span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
